var _react_refresh_temp_1;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { C } from '#integrations';
import { Box } from '../Box';
import { Typography } from '../Typography';
import { INDICATOR_COLOR, INDICATOR_MAX_COUNT, INDICATOR_OVERFLOW_LABEL, INDICATOR_SIZE, } from './Indicator.constants';
import { IndicatorTestIdFactory } from './interactions';
import styles from './Indicator.module.css';
const SIZE_CLASS_MAP = {
    large: styles.Large,
    small: styles.Small,
    tiny: styles.Tiny,
};
const COLOR_CLASS_MAP = {
    alert: styles.Alert,
    danger: styles.Danger,
    highlight: styles.Highlight,
    informative: styles.Informative,
    neutral: styles.Neutral,
    positive: styles.Positive,
};
const ICON_SIZE_MAP = {
    [INDICATOR_SIZE.LARGE]: 'xsmall',
    [INDICATOR_SIZE.SMALL]: 'xxsmall',
};
const TYPOGRAPHY_KIND_MAP = {
    [INDICATOR_SIZE.LARGE]: 'generic-small',
    [INDICATOR_SIZE.SMALL]: 'generic-tiny',
};
export const Indicator = ({ className, content, 'data-testid': testId, label, size = INDICATOR_SIZE.SMALL, variant = INDICATOR_COLOR.HIGHLIGHT, }) => {
    const isTiny = size === INDICATOR_SIZE.TINY;
    const isIcon = !isTiny && typeof content === 'function';
    const isNumber = !isTiny && typeof content === 'number';
    const Icon = isIcon ? content : null;
    return (_jsxs(Box, { align: "center", className: C(styles.Container, SIZE_CLASS_MAP[size], COLOR_CLASS_MAP[variant], isNumber && styles.NumberContent, className), ...(testId && {
            'data-testid': IndicatorTestIdFactory.getIndicatorTestId(testId),
        }), justify: "center", radius: "m", children: [Icon && (_jsx(Icon, { size: ICON_SIZE_MAP[size] })), isNumber && (_jsx(Typography, { color: "inherit", fontWeight: "medium", kind: TYPOGRAPHY_KIND_MAP[size], children: content > INDICATOR_MAX_COUNT
                    ? INDICATOR_OVERFLOW_LABEL
                    : content })), label && _jsx(Box, { isVisuallyHidden: true, children: label })] }));
};
_react_refresh_temp_1 = Indicator;
$RefreshReg$(_react_refresh_temp_1, "Indicator");
